<template>
<div class="perk"
	@mouseenter="play()"
	@mouseleave="pause()"
>
	<div class="choice pad border">
		<h4>{{ pluralize( perks[perks[choice.perk]].human_readable, choice.count ) }}</h4>
		<div ref="previewRef"
			class="center-text preview"
			v-html="preview_html()"
		/>
		<p>{{ perks[perks[choice.perk]].description }}</p>
		<p>
			<strong>{{ choice.count ? choice.count + '&nbsp;' : '' }}</strong>
			<span
				v-if="perks[perks[choice.perk]].permanent"
				class="permanent highlight"
				title="Permanent choices may still be used even if your subscription expires in the future"
			>permanent</span>
			<span
				v-if="perks[perks[choice.perk]].exclusive"
				class="exclusve highlight"
				title="Exclusive choices are limited to this month's subscriber bonus choice and won't appear as an option in a future subscriber bonus choice"
			>exclusive</span>
			{{ pluralize( perks[perks[choice.perk]].human_readable.toLowerCase(), choice.count ) }}.
		</p>
		<p v-if="perks[perks[choice.perk]].subscriber_increase">
			<sub>Quintupled to <strong> {{ choice.count * 5 }}</strong> slots when you're an active subscriber!</sub>
		</p>
		<div class="center-text bottom pad-top">
			<a class="button" @click.prevent="submitChoice">Choose {{ perks[perks[choice.perk]].human_readable }}</a>
		</div>
	</div>
</div>
</template>

<script>
import perks from '../json/shared/perks.json'
import socket from '../js/socket.js'

export default {
	props: {
		choice: {
			type: Object,
			required: true
		},
		index: {
			type: Number,
			required: true
		}
	},
	data: () => ({
		perks: perks
	}),
	methods: {
		preview_html(){
			return perks[perks[this.choice.perk]].preview_html
		},
		pluralize: ( string, count ) => {
			return string + ( count > 1 ? 's' : '' )
		},
		play(){
			this.$refs.previewRef.getElementsByTagName( 'video' )[0] && this.$refs.previewRef.getElementsByTagName( 'video' )[0].play()
		},
		pause(){
			this.$refs.previewRef.getElementsByTagName( 'video' )[0] && this.$refs.previewRef.getElementsByTagName( 'video' )[0].pause()
		},
		submitChoice(){
			socket.emit( 'choice', this.index )
		}
	}
}
</script>